<template>
    <div :class="$attrs.class">
        <label :for="id" v-if="label" class="block text-sm font-medium text-gray-700">{{ label }}:</label>
        <div
            :class="{ error: error }"
            class="relative mt-1 w-full border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-reethi-purple focus:border-reethi-purple sm:text-sm">
            <span v-if="hasIcon" class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                <slot />
            </span>
            <input
                :id="id"
                :value="modelValue"
                @input="inputChanged($event)"
                v-bind="{ ...$attrs, class: null }"
                :type="this.showPassword ? '' : type"
                class="appearance-none w-full py-2 bg-transparent"
                :placeholder="placeholder || 'Please type in the info'"
                :class="{ 'pl-10': hasIcon, 'px-2': !hasIcon, 'pr-10': type === 'password' }"/>
            <div v-if="type === 'password'" class="absolute cursor-pointer inset-y-0 right-2 flex items-center pl-2" @click.stop="togglePasswordVisibility">
                <EyeIcon v-if="!this.showPassword" class="h-6 text-gray-500"/>
                <EyeOffIcon v-if="this.showPassword" class="h-6 text-gray-500"/>
            </div>
        </div>
        <div v-if="error" class="form-error">{{ error }}</div>
    </div>
</template>

<script>
import {v4 as uuid} from 'uuid'
import { EyeIcon, EyeOffIcon } from '@heroicons/vue/outline'

export default {
    inheritAttrs: false,
    components: {
        EyeIcon,
        EyeOffIcon
    },
    props: {
        id: {
            type: String,
            default() {
                return `text-input-${uuid()}`
            },
        },
        type: {
            type: String,
            default: 'text',
        },
        icon: String,
        error: String,
        label: String,
        onChange: Function,
        modelValue: String,
        placeholder: String,
    },
    emits: ['update:modelValue'],
    data() {
      return {
          showPassword: false
      }
    },
    computed: {
        hasIcon() {
            return !!this.$slots.default
        }
    },
    methods: {
        inputChanged($event) {
            if (this.onChange) {
                this.onChange($event.target.value)
            }
            this.$emit('update:modelValue', $event.target.value)
        },
        togglePasswordVisibility() {
            this.showPassword = !this.showPassword;
        }
    },
}
</script>
